import {formatPercent, formatPhone} from '@deliveriesondemand/dod-utils';
import {formatMoney} from 'accounting';
import moment from 'moment';
import {Component, Fragment} from 'react';
import injectSheet from 'react-jss';
import {connect} from 'react-redux';

import Button from '-/components/general/Button';
import Countdown from '-/components/general/Countdown';
import {Icons} from '-/icons/icons';
import {formatCreditorName} from '-/util/util';

const prefix = '/?offerId=';

const styles = theme => ({
    reveal: {
        padding: '0 20px',
        textAlign: 'center',
        '& h1': {
            lineHeight: '48px'
        },
        '& h2': {
            fontSize: 21,
            fontWeight: 'inherit',
            lineHeight: '22px'
        },
        '& h2, p, ul': {
            marginBottom: 20
        },
        '& h3': {
            marginBottom: 10
        },
        '@media all and (max-width: 720px)': {
            '& h1': {
                fontSize: 22,
                fontWeight: 'bold',
                lineHeight: '22px'
            },
            '& h2': {
                fontSize: 17
            },
            '& h1, h2, p, ul': {
                margin: '8px 0'
            }
        }
    },
    offerCards: {
        '& .newOffer': {
            '-webkit-border-radius': 12,
            '-moz-border-radius': 12,
            backgroundColor: 'white',
            border: '1px solid gray',
            borderRadius: 20,
            color: 'black',
            display: 'inline-block',
            marginBottom: 20,
            padding: 15,
            width: '50%',
            '& p': {
                marginBottom:5
            },
            '& img': {
                width: '40%'
            },
            '@media all and (max-width: 720px)': {
                marginBottom: 0,
                padding: 10,
                width: '95%'
            }
        }
    },
    countdown: {
        color: theme.colors.primary
    },
    link: {
        color: theme.colors.primary,
        textDecoration: 'underline'
    }
});

class Reveal extends Component {
    handleGoToOffer(link) {
        window.location.href = link;
    }

    render() {
        const {classes = {}, contactPhone = '', creditorName, offer = {}} = this.props;
        const {encodedOffer, dob, name, dealInfo = {}, segmentInfo = {}} = offer;
        const {deferredDays, existingRate, giftAmount, lifeTimeSavings, newRate} = dealInfo;
        const {goodUntil = moment().endOf('month')} = segmentInfo;
        const link = `${prefix}${encodedOffer}&authorized=1&authType=dob&authInfo=${dob}`;

        const formattedCreditorName = formatCreditorName(creditorName);

        return (
            <div className={classes.reveal}>
                <h1>Congratulations, {name}</h1>
                <h2>
                    You are <b>pre-approved</b> to lower your auto loan
                    rate from <b>{formatPercent(existingRate, 'dynamic')}</b> to <b>{formatPercent(newRate, 'dynamic')}</b>.
                </h2>
                <div className={classes.offerCards}>
                    <div className="newOffer">
                        <h3>{formattedCreditorName}&apos;s offer</h3>
                        <p><img src={Icons.CARBLACK} /></p>
                        <p>New lower rate<sup>*</sup>: <b>{formatPercent(newRate, 'dynamic')}</b></p>
                        <p>Save<sup>*</sup> about <b>{formatMoney(lifeTimeSavings)}</b> in interest</p>
                        <p>No payments for <b>{deferredDays} DAYS<sup>*</sup></b></p>
                        {giftAmount && (
                            <p>Get a <b>{formatMoney(giftAmount)}</b> gift card<sup>*</sup> at closing</p>
                        )}
                    </div>
                </div>
                <p>
                    Click below or call <a className={classes.link} href={`tel:${contactPhone}`}>{formatPhone(contactPhone)}</a> to
                    Claim your Savings Today.
                </p>
                <Button onClick={() => this.handleGoToOffer(link)}>Claim your Savings Today</Button>
                {goodUntil && (
                    <Fragment>
                        <h3>Birthday Offer Expires:</h3>
                        <Countdown date={goodUntil} />
                    </Fragment>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {navigation, config, creditor} = state;
    const {name: creditorName} = creditor;
    const {currentStepData: offer = {}} = navigation;
    const {contactPhone} = config;
    return {
        contactPhone,
        creditorName,
        offer
    };
};

export default connect(mapStateToProps)(injectSheet(styles)(Reveal));